// @ts-nocheck
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  ChatBubbleLeftRightIcon,
  CheckCircleIcon,
  ClockIcon,
  LifebuoyIcon,
  PaperAirplaneIcon,
  PlusIcon,
  TicketIcon,
  UserGroupIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { getCurrentRole } from "../../components/RoleRoute";
import { URL } from "../../service/Service";

const HELP = [
  [
    "Criar e publicar um formulário",
    "Crie o formulário, configure os campos, pagamentos e marca. No último passo publique-o e partilhe o URL público.",
    "formulário criar publicar campos url partilhar",
  ],
  [
    "Formulário bloqueado",
    "Um formulário bloqueado não aceita acessos nem respostas. Se o bloqueio foi administrativo, crie um ticket para a administração analisar.",
    "bloqueado bloqueio fraude acesso",
  ],
  [
    "Formulário expirado",
    "Confirme a data de expiração nas definições. No dia seguinte à data indicada, o formulário deixa de aceitar respostas.",
    "expirado data validade",
  ],
  [
    "Não recebo respostas",
    "Confirme se o formulário está publicado, ativo, não expirou e se está a usar o URL público correto.",
    "respostas não recebe submissão",
  ],
  [
    "Pagamento pendente",
    "O pagamento fica confirmado automaticamente quando a Eupago envia a notificação. Em Encomendas, use “Atualização de referências” apenas quando quiser consultar manualmente referências que continuem pendentes.",
    "pagamento pendente callback pago eupago",
  ],
  [
    "Chave API Eupago",
    "Configure as credenciais Eupago na conta da empresa e confirme que o formulário usa o mesmo canal. Nunca coloque a chave numa página pública.",
    "api chave credenciais client id secret canal",
  ],
  [
    "MB WAY",
    "Introduza um telemóvel português válido e confirme o pedido na aplicação MB WAY dentro do prazo. Confirme também se o método está ativo no canal Eupago.",
    "mbway telemóvel pagamento aplicação",
  ],
  [
    "Multibanco",
    "A entidade e referência são geradas depois de finalizar. O estado muda automaticamente quando a Eupago confirma o pagamento.",
    "multibanco referência entidade",
  ],
  [
    "Cartão, Apple Pay e Google Pay",
    "A disponibilidade depende dos métodos ativos no canal Eupago e, no caso das carteiras digitais, do dispositivo e browser do comprador.",
    "cartão apple google pay visa mastercard",
  ],
  [
    "FLOA",
    "A FLOA só aparece quando está ativa no canal e o montante da compra respeita os limites configurados.",
    "floa prestações",
  ],
  [
    "Reembolso",
    "Abra a resposta ou encomenda paga e peça o reembolso. A conclusão depende da confirmação do prestador.",
    "reembolso devolver dinheiro",
  ],
  [
    "Criar um produto",
    "No Catálogo escolha Adicionar produto e preencha nome, SKU, preço, stock, descrição, imagem e traduções.",
    "produto criar catálogo sku",
  ],
  [
    "Imagem do produto não aparece",
    "Use JPG, PNG ou WebP até 5 MB. Aguarde pelo fim do upload, guarde o produto e confirme que o endereço da imagem está acessível.",
    "imagem foto produto upload não aparece",
  ],
  [
    "Tamanhos, cores e opções",
    "Escolha um produto com opções e crie atributos como Tamanho, Cor, Dia ou Zona. O cliente seleciona-os antes de adicionar ao cesto.",
    "tamanho cor variante opção atributo",
  ],
  [
    "Stock e reservas",
    "O stock disponível é o total menos o reservado. Uma compra pendente pode reservar unidades temporariamente.",
    "stock reservado inventário",
  ],
  [
    "Loja pública",
    "Use Ver loja pública no Catálogo. Apenas produtos publicados, com stock adequado e catálogo ativo ficam disponíveis.",
    "loja pública catálogo cliente",
  ],
  [
    "Checkout indisponível",
    "Confirme que o catálogo e o checkout estão ativos, existe um destino de entrega e há métodos de pagamento disponíveis.",
    "checkout desativado indisponível",
  ],
  [
    "Portes e morada",
    "Ative Portugal ou Espanha em Entregas e portes e defina o preço. O código postal tem de corresponder ao destino selecionado.",
    "morada portes entrega código postal",
  ],
  [
    "Preparar e enviar encomenda",
    "Quando o pagamento estiver Pago, abra Gerir encomenda, introduza o código de tracking e marque-a como enviada.",
    "encomenda expedição tracking enviar",
  ],
  [
    "Conta bloqueada",
    "Por segurança não é possível iniciar sessão numa conta bloqueada. Crie um ticket e indique o email da conta para a administração analisar.",
    "conta login bloqueio bloqueada inativa",
  ],
  [
    "Equipa e permissões",
    "A empresa gere a própria equipa; o administrador gere todas as contas. Cada perfil vê apenas as áreas autorizadas.",
    "equipa utilizador permissões perfil role",
  ],
  [
    "Exportar dados",
    "Use Exportar CSV nas respostas ou encomendas. Pode pesquisar e filtrar os registos antes de exportar.",
    "exportar csv dados",
  ],
  [
    "Duplicar um formulário",
    "Na lista de formulários escolha Duplicar. É criada uma cópia em rascunho para poder alterar campos e definições sem afetar o original.",
    "duplicar copiar clonar formulário rascunho",
  ],
  [
    "Editar um formulário publicado",
    "Pode editar campos e definições de um formulário publicado. Reveja as alterações antes de guardar; as respostas já recebidas mantêm os dados históricos.",
    "editar alterar formulário publicado campos",
  ],
  [
    "Partilhar o formulário",
    "Use Copiar URL na gestão do formulário e envie esse endereço aos participantes. Use Ver público para confirmar primeiro o resultado.",
    "partilhar link url copiar formulário público",
  ],
  [
    "Notificações de novas respostas",
    "Confirme o email de notificações nas definições do formulário e verifique também a pasta de spam. As respostas continuam disponíveis na plataforma mesmo que o email falhe.",
    "notificação email nova resposta spam",
  ],
  [
    "Pagamento falhado",
    "Peça ao cliente para confirmar os dados e tentar novamente. Não marque o pagamento manualmente: o estado válido é sempre recebido do prestador de pagamentos.",
    "pagamento falhou falhado recusado erro tentar novamente",
  ],
  [
    "Referência Multibanco expirada",
    "Uma referência expirada já não pode ser paga. O cliente deve iniciar uma nova submissão ou encomenda para gerar novos dados de pagamento.",
    "referência multibanco expirou expirada nova",
  ],
  [
    "Código de tracking",
    "O tracking é introduzido ao preparar o envio de uma encomenda paga. Depois de confirmar, fica visível no detalhe da encomenda.",
    "tracking código transportadora expedição envio",
  ],
  [
    "Produto sem stock",
    "Confirme o stock total e as unidades reservadas. Reponha o stock na gestão do produto; produtos sem unidades disponíveis não podem ser adicionados ao cesto.",
    "produto sem stock esgotado unidades repor",
  ],
  [
    "Produto não aparece na loja",
    "Confirme se o produto está publicado, se o catálogo e o checkout estão ativos e se existe stock. Produtos arquivados ou em rascunho não aparecem ao cliente.",
    "produto não aparece loja publicado arquivado rascunho",
  ],
  [
    "Alterar preço ou SKU",
    "Edite o produto no Catálogo. O novo preço e SKU aplicam-se a compras futuras; as encomendas existentes mantêm os valores registados no momento da compra.",
    "alterar preço sku produto histórico",
  ],
  [
    "Cancelar uma encomenda",
    "Uma encomenda pendente pode ser abandonada sem expedição. Se já estiver paga, confirme primeiro se deve ser reembolsada e preserve o histórico da operação.",
    "cancelar encomenda compra paga pendente",
  ],
  [
    "Dados do cliente incorretos",
    "Confirme a informação no detalhe da resposta ou encomenda. Para proteger o histórico, os dados submetidos não devem ser substituídos; peça uma nova submissão quando necessário.",
    "cliente morada email nome dados incorretos corrigir",
  ],
  [
    "Não consigo iniciar sessão",
    "Confirme o email, use Recuperar palavra-passe e verifique a caixa de spam. Se a conta estiver bloqueada ou não receber o email, crie um ticket para a administração.",
    "login iniciar sessão password palavra passe recuperar",
  ],
  [
    "Alterar idioma",
    "Use o seletor Idioma no topo da plataforma. O idioma do backoffice e as traduções apresentadas no formulário ou catálogo são configurações distintas.",
    "idioma português inglês espanhol tradução",
  ],
  [
    "Problema técnico no browser",
    "Atualize a página, teste numa janela privada e limpe a cache. Se continuar, crie um ticket com a página, hora, browser e uma captura do erro.",
    "browser navegador cache página erro técnico",
  ],
];

const QUICK_TOPICS = [
  "Pagamento pendente",
  "Pagamento falhado",
  "Formulário bloqueado",
  "Não recebo respostas",
  "Produto não aparece na loja",
  "Imagem do produto não aparece",
  "Produto sem stock",
  "Preparar e enviar encomenda",
  "Código de tracking",
  "Reembolso",
  "Não consigo iniciar sessão",
  "Problema técnico no browser",
];
const CATEGORIES = {
  FORMS: "Formulários",
  PAYMENTS: "Pagamentos",
  CATALOG: "Catálogo",
  ORDERS: "Encomendas",
  ACCOUNT: "Conta",
  SECURITY: "Segurança",
  OTHER: "Outro",
};
const STATUSES = {
  OPEN: "Aberto",
  IN_PROGRESS: "Em análise",
  WAITING_CUSTOMER: "A aguardar cliente",
  RESOLVED: "Resolvido",
  CLOSED: "Fechado",
};
const STATUS_STYLE = {
  OPEN: "bg-blue-50 text-blue-700",
  IN_PROGRESS: "bg-amber-50 text-amber-700",
  WAITING_CUSTOMER: "bg-violet-50 text-violet-700",
  RESOLVED: "bg-emerald-50 text-emerald-700",
  CLOSED: "bg-slate-100 text-slate-600",
};
const normalize = (value = "") =>
  value
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
const SYNONYMS = {
  foto: "imagem", fotografia: "imagem", bloqueio: "bloqueado", pausa: "bloqueado",
  pagar: "pagamento", paguei: "pago", dinheiro: "pagamento", envio: "expedicao",
  entrega: "expedicao", encomendar: "encomenda", comprar: "checkout", login: "sessao",
  password: "palavra-passe", senha: "palavra-passe", link: "url", ligação: "url",
};
const distance = (a, b) => {
  const row = Array.from({ length: b.length + 1 }, (_, i) => i);
  for (let i = 1; i <= a.length; i += 1) {
    let previous = row[0]; row[0] = i;
    for (let j = 1; j <= b.length; j += 1) {
      const saved = row[j]; row[j] = Math.min(row[j] + 1, row[j - 1] + 1, previous + (a[i - 1] === b[j - 1] ? 0 : 1)); previous = saved;
    }
  }
  return row[b.length];
};
const findAnswer = (question) => {
  const words = normalize(question)
    .split(/\s+/)
    .filter((word) => word.length > 2)
    .map((word) => SYNONYMS[word] || word);
  return HELP.map((item) => ({
    item,
    score: words.reduce((score, word) => {
      const candidates = normalize(item.join(" ")).split(/\s+/);
      const exact = candidates.some((candidate) => candidate.includes(word) || word.includes(candidate));
      const fuzzy = word.length > 4 && candidates.some((candidate) => candidate.length > 4 && distance(word, candidate) <= 2);
      return score + (exact ? 3 : fuzzy ? 1 : 0);
    }, 0),
  })).sort((a, b) => b.score - a.score)[0];
};

export default function Support() {
  const role = getCurrentRole();
  const admin = role === "ADMIN";
  const headers = useMemo(
    () => ({
      Authorization: `Bearer ${sessionStorage.getItem("jwt")}`,
      "Content-Type": "application/json",
    }),
    [],
  );
  const [tickets, setTickets] = useState([]),
    [selected, setSelected] = useState(null);
  const [filter, setFilter] = useState("ALL"),
    [loading, setLoading] = useState(true),
    [error, setError] = useState("");
  const [creating, setCreating] = useState(false),
    [reply, setReply] = useState(""),
    [question, setQuestion] = useState("");
  const [form, setForm] = useState({
    category: "FORMS",
    subject: "",
    description: "",
    priority: "NORMAL",
  });
  const [chat, setChat] = useState([
    {
      from: "bot",
      text: "Olá! Sou o assistente virtual. Diga-me o que pretende resolver e tento dar-lhe uma resposta imediata.",
    },
  ]);
  const chatEndRef = useRef(null);

  const loadTickets = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetch(`${URL}/api/support/tickets`, { headers });
      if (!response.ok)
        throw new Error(
          (await response.text()) || "Não foi possível carregar os tickets.",
        );
      const data = await response.json();
      setTickets(data);
      setSelected((current) =>
        current
          ? data.find((ticket) => ticket.id === current.id) || null
          : null,
      );
      setError("");
    } catch (exception) {
      setError(exception.message);
    } finally {
      setLoading(false);
    }
  }, [headers]);
  useEffect(() => {
    loadTickets();
  }, [loadTickets]);
  useEffect(() => {
    if (!admin) return undefined;
    const refresh = window.setInterval(loadTickets, 30000);
    return () => window.clearInterval(refresh);
  }, [admin, loadTickets]);
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
    });
  }, [chat]);

  const ask = (text = question) => {
    const clean = text.trim();
    if (!clean) return;
    const result = findAnswer(clean);
    const answer =
      result?.score >= 2
        ? `${result.item[0]} — ${result.item[1]}`
        : "Não encontrei uma resposta segura para essa questão. Posso encaminhá-la para a administração através de um ticket.";
    setChat((messages) => [
      ...messages,
      { from: "user", text: clean },
      {
        from: "bot",
        text: answer,
        topic: result?.score >= 2 ? result.item[0] : null,
        unresolved: !result || result.score < 2,
      },
    ]);
    setQuestion("");
  };
  const openTicketFromChat = () => {
    const last =
      [...chat].reverse().find((message) => message.from === "user")?.text ||
      "";
    setForm((current) => ({
      ...current,
      subject: last.slice(0, 180),
      description: `Conversa com o assistente virtual:\n\n${chat.map((message) => `${message.from === "user" ? "Cliente" : "Assistente"}: ${message.text}`).join("\n\n")}\n\nÚltima questão: ${last}`.slice(0, 5000),
    }));
    setCreating(true);
  };
  const createTicket = async (event) => {
    event.preventDefault();
    try {
      const response = await fetch(`${URL}/api/support/tickets`, {
        method: "POST",
        headers,
        body: JSON.stringify(form),
      });
      if (!response.ok)
        throw new Error(
          (await response.text()) || "Não foi possível criar o ticket.",
        );
      const ticket = await response.json();
      setCreating(false);
      setForm({
        category: "FORMS",
        subject: "",
        description: "",
        priority: "NORMAL",
      });
      setChat((messages) => [
        ...messages,
        {
          from: "bot",
          text: `Ticket #${ticket.id.slice(0, 8)} criado. A administração recebeu o pedido e poderá responder nesta área.`,
        },
      ]);
      window.dispatchEvent(new Event("support-notifications-updated"));
      await loadTickets();
      setSelected(ticket);
    } catch (exception) {
      setError(exception.message);
    }
  };
  const sendReply = async () => {
    if (!reply.trim() || !selected) return;
    try {
      const response = await fetch(
        `${URL}/api/support/tickets/${selected.id}/messages`,
        { method: "POST", headers, body: JSON.stringify({ message: reply }) },
      );
      if (!response.ok)
        throw new Error(
          (await response.text()) || "Não foi possível enviar a resposta.",
        );
      const ticket = await response.json();
      setReply("");
      setSelected(ticket);
      window.dispatchEvent(new Event("support-notifications-updated"));
      await loadTickets();
    } catch (exception) {
      setError(exception.message);
    }
  };
  const changeStatus = async (status) => {
    try {
      const response = await fetch(
        `${URL}/api/support/tickets/${selected.id}/status`,
        { method: "PATCH", headers, body: JSON.stringify({ status }) },
      );
      if (!response.ok)
        throw new Error(
          (await response.text()) || "Não foi possível alterar o estado.",
        );
      const ticket = await response.json();
      setSelected(ticket);
      window.dispatchEvent(new Event("support-notifications-updated"));
      await loadTickets();
    } catch (exception) {
      setError(exception.message);
    }
  };
  const visibleTickets =
    filter === "ALL"
      ? tickets
      : tickets.filter((ticket) => ticket.status === filter);
  const activeCount = tickets.filter(
    (ticket) => !["RESOLVED", "CLOSED"].includes(ticket.status),
  ).length;
  const topicOffset =
    Math.floor(Math.max(chat.length - 1, 0) / 2) % (QUICK_TOPICS.length - 5);
  const suggestedTopics = QUICK_TOPICS.filter(
    (topic) => topic !== chat.at(-1)?.topic,
  ).slice(topicOffset, topicOffset + 6);

  return (
    <main className="min-h-screen bg-slate-50 px-5 py-8 text-slate-900 lg:px-10">
      <div className="mx-auto max-w-7xl">
        <header className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs font-bold uppercase tracking-[.22em] text-emerald-700">
              {admin ? "Suporte da plataforma" : "Centro de ajuda"}
            </p>
            <h1 className="mt-2 text-3xl font-black">
              {admin ? "Tickets de suporte" : "Ajuda e suporte"}
            </h1>
            <p className="mt-2 text-sm text-slate-500">
              {admin
                ? "Receba, acompanhe e responda aos pedidos dos clientes."
                : "Converse com o assistente ou peça ajuda à administração."}
            </p>
          </div>
          {!admin && (
            <button
              onClick={() => setCreating(true)}
              className="inline-flex items-center justify-center gap-2 rounded-xl bg-emerald-900 px-5 py-3 font-bold text-white hover:bg-emerald-800"
            >
              <PlusIcon className="h-5 w-5" />
              Criar ticket
            </button>
          )}
        </header>
        {error && (
          <div className="mt-5 rounded-2xl border border-red-200 bg-red-50 p-4 text-sm font-bold text-red-700">
            {error}
          </div>
        )}
        {admin ? (
          <>
            <div className="mt-7 grid gap-4 sm:grid-cols-3">
              <Metric
                icon={TicketIcon}
                label="Total de tickets"
                value={tickets.length}
              />
              <Metric icon={ClockIcon} label="Por tratar" value={activeCount} />
              <Metric
                icon={CheckCircleIcon}
                label="Resolvidos"
                value={
                  tickets.filter((ticket) => ticket.status === "RESOLVED")
                    .length
                }
              />
            </div>
            <TicketPanel
              admin
              tickets={visibleTickets}
              total={tickets.length}
              selected={selected}
              setSelected={setSelected}
              loading={loading}
              filter={filter}
              setFilter={setFilter}
            />
          </>
        ) : (
          <div className="mt-7 grid gap-6 lg:grid-cols-[1.08fr_.92fr]">
            <section className="flex min-h-[610px] flex-col overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm">
              <div className="flex items-center gap-3 border-b border-slate-100 p-6">
                <span className="rounded-2xl bg-emerald-50 p-3 text-emerald-700">
                  <ChatBubbleLeftRightIcon className="h-6 w-6" />
                </span>
                <div>
                  <h2 className="text-xl font-black">Assistente virtual</h2>
                  <p className="text-sm text-slate-500">
                    Resposta imediata, com encaminhamento humano quando
                    necessário.
                  </p>
                </div>
                <span className="ml-auto flex items-center gap-2 text-xs font-bold text-emerald-700">
                  <span className="h-2 w-2 rounded-full bg-emerald-500" />
                  Online
                </span>
              </div>
              <div className="flex-1 space-y-4 overflow-y-auto bg-slate-50/60 p-6">
                {chat.map((message, index) => (
                  <div
                    key={index}
                    className={`flex ${message.from === "user" ? "justify-end" : "justify-start"}`}
                  >
                    <div
                      className={`max-w-[85%] rounded-2xl px-4 py-3 text-sm leading-6 ${message.from === "user" ? "rounded-br-md bg-emerald-900 text-white" : "rounded-bl-md border border-slate-200 bg-white text-slate-700"}`}
                    >
                      <p>{message.text}</p>
                      {message.unresolved && (
                        <button
                          onClick={openTicketFromChat}
                          className="mt-3 rounded-lg border border-emerald-200 px-3 py-2 font-bold text-emerald-800"
                        >
                          Criar ticket para o admin
                        </button>
                      )}
                    </div>
                  </div>
                ))}
                <div className="rounded-2xl border border-slate-200 bg-white p-3">
                  <p className="mb-2 text-xs font-bold uppercase tracking-wide text-slate-400">
                    {chat.length === 1
                      ? "Perguntas frequentes"
                      : "Posso ajudar também com"}
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {suggestedTopics.map((topic) => (
                      <button
                        key={topic}
                        onClick={() => ask(topic)}
                        className="rounded-full border border-slate-200 bg-white px-3 py-2 text-xs font-bold text-slate-600 hover:border-emerald-300 hover:text-emerald-800"
                      >
                        {topic}
                      </button>
                    ))}
                  </div>
                  <p className="mt-3 text-xs text-slate-500">
                    Pode escolher uma sugestão ou escrever outra pergunta
                    abaixo.
                  </p>
                </div>
                <div ref={chatEndRef} />
              </div>
              <div className="border-t border-slate-100 bg-white p-4">
                <div className="flex gap-2 rounded-2xl border border-slate-200 p-2 focus-within:border-emerald-400">
                  <input
                    value={question}
                    onChange={(event) => setQuestion(event.target.value)}
                    onKeyDown={(event) => event.key === "Enter" && ask()}
                    className="min-w-0 flex-1 border-0 px-2 focus:ring-0"
                    placeholder="Escreva a sua dúvida…"
                  />
                  <button
                    onClick={() => ask()}
                    className="rounded-xl bg-emerald-900 p-3 text-white"
                    aria-label="Enviar pergunta"
                  >
                    <PaperAirplaneIcon className="h-5 w-5" />
                  </button>
                </div>
                <button
                  onClick={openTicketFromChat}
                  className="mt-3 w-full text-center text-xs font-bold text-emerald-800"
                >
                  Prefiro falar com a administração
                </button>
              </div>
            </section>
            <TicketPanel
              tickets={tickets}
              total={tickets.length}
              selected={selected}
              setSelected={setSelected}
              loading={loading}
            />
          </div>
        )}
      </div>
      {creating && (
        <TicketForm
          form={form}
          setForm={setForm}
          close={() => setCreating(false)}
          submit={createTicket}
        />
      )}
      {selected && (
        <TicketDetail
          ticket={selected}
          admin={admin}
          close={() => setSelected(null)}
          reply={reply}
          setReply={setReply}
          sendReply={sendReply}
          changeStatus={changeStatus}
        />
      )}
    </main>
  );
}

function Metric({ icon: Icon, label, value }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-bold text-slate-500">{label}</p>
          <p className="mt-2 text-3xl font-black">{value}</p>
        </div>
        <Icon className="h-8 w-8 text-emerald-700" />
      </div>
    </div>
  );
}
function TicketPanel({
  admin = false,
  tickets,
  total,
  selected,
  setSelected,
  loading,
  filter,
  setFilter,
}) {
  return (
    <section
      className={`${admin ? "mt-6" : ""} rounded-3xl border border-slate-200 bg-white p-6 shadow-sm`}
    >
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <LifebuoyIcon className="h-7 w-7 text-emerald-700" />
          <div>
            <h2 className="text-xl font-black">
              {admin ? "Caixa de entrada" : "Os meus tickets"}
            </h2>
            <p className="text-sm text-slate-500">{total} ticket(s)</p>
          </div>
        </div>
        {admin && (
          <select
            aria-label="Filtrar tickets por estado"
            value={filter}
            onChange={(event) => setFilter(event.target.value)}
            className="rounded-xl border-slate-200 py-2 text-sm"
          >
            <option value="ALL">Todos os estados</option>
            {Object.entries(STATUSES).map(([value, label]) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
        )}
      </div>
      <div
        className={`mt-5 ${admin ? "grid gap-3 md:grid-cols-2" : "space-y-3"}`}
      >
        {tickets.map((ticket) => (
          <button
            key={ticket.id}
            onClick={() => setSelected(ticket)}
            className={`w-full rounded-2xl border p-4 text-left transition hover:border-emerald-300 hover:shadow-sm ${selected?.id === ticket.id ? "border-emerald-400 bg-emerald-50/50" : "border-slate-200"}`}
          >
            <span className="flex items-start justify-between gap-3">
              <b className="line-clamp-2">{ticket.subject}</b>
              <small
                className={`whitespace-nowrap rounded-full px-2 py-1 font-bold ${STATUS_STYLE[ticket.status]}`}
              >
                {STATUSES[ticket.status]}
              </small>
            </span>
            <small className="mt-2 block text-slate-500">
              {CATEGORIES[ticket.category]}
              {admin ? ` · ${ticket.requesterEmail}` : ""}
            </small>
            <small className="mt-1 block text-slate-400">
              Atualizado em {new Date(ticket.updatedAt).toLocaleString("pt-PT")}
            </small>
          </button>
        ))}
        {!loading && !tickets.length && (
          <div className="py-16 text-center text-sm text-slate-500">
            <TicketIcon className="mx-auto mb-3 h-10 w-10 text-slate-300" />
            {admin
              ? "Não existem tickets neste estado."
              : "Ainda não criou nenhum ticket."}
          </div>
        )}
        {loading && (
          <p className="py-12 text-center text-sm text-slate-500">
            A carregar tickets…
          </p>
        )}
      </div>
    </section>
  );
}
function TicketForm({ form, setForm, close, submit }) {
  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-slate-950/60 p-4">
      <form
        onSubmit={submit}
        className="w-full max-w-xl rounded-3xl bg-white p-6 shadow-2xl"
      >
        <div className="flex items-start justify-between">
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-emerald-700">
              Contacto com a administração
            </p>
            <h2 className="mt-2 text-2xl font-black">Criar ticket</h2>
          </div>
          <button
            type="button"
            onClick={close}
            className="rounded-xl border p-2"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>
        <label className="mt-5 block text-sm font-bold">
          Área
          <select
            value={form.category}
            onChange={(event) =>
              setForm({ ...form, category: event.target.value })
            }
            className="mt-2 w-full rounded-xl border-slate-200"
          >
            {Object.entries(CATEGORIES).map(([value, label]) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
        </label>
        <label className="mt-4 block text-sm font-bold">
          Assunto
          <input
            required
            maxLength={180}
            value={form.subject}
            onChange={(event) =>
              setForm({ ...form, subject: event.target.value })
            }
            placeholder="Resumo do problema"
            className="mt-2 w-full rounded-xl border-slate-200"
          />
        </label>
        <label className="mt-4 block text-sm font-bold">
          Descrição
          <textarea
            required
            maxLength={5000}
            value={form.description}
            onChange={(event) =>
              setForm({ ...form, description: event.target.value })
            }
            placeholder="Explique o que aconteceu, onde aconteceu e o que esperava que acontecesse"
            className="mt-2 min-h-36 w-full rounded-xl border-slate-200"
          />
        </label>
        <p className="mt-3 text-xs text-slate-500">
          O pedido será enviado diretamente para a caixa de entrada da
          administração.
        </p>
        <div className="mt-5 flex justify-end gap-3">
          <button
            type="button"
            onClick={close}
            className="rounded-xl border px-4 py-2"
          >
            Cancelar
          </button>
          <button className="rounded-xl bg-emerald-900 px-4 py-2 font-bold text-white">
            Enviar ticket
          </button>
        </div>
      </form>
    </div>
  );
}
function TicketDetail({
  ticket,
  admin,
  close,
  reply,
  setReply,
  sendReply,
  changeStatus,
}) {
  return (
    <div
      className="fixed inset-0 z-50 flex justify-end bg-slate-950/60"
      onMouseDown={(event) => event.target === event.currentTarget && close()}
    >
      <aside className="flex h-full w-full max-w-2xl flex-col bg-slate-50 shadow-2xl">
        <header className="border-b border-slate-200 bg-white p-6">
          <button onClick={close} className="float-right rounded-xl border p-2">
            <XMarkIcon className="h-5 w-5" />
          </button>
          <p className="text-xs font-bold uppercase tracking-widest text-emerald-700">
            Ticket #{ticket.id.slice(0, 8)}
          </p>
          <h2 className="mt-2 pr-12 text-2xl font-black">{ticket.subject}</h2>
          <p className="mt-2 text-sm text-slate-500">
            {ticket.requesterEmail} · {CATEGORIES[ticket.category]}
          </p>
          {admin ? (
            <label className="mt-5 block text-sm font-bold">
              Estado
              <select
                value={ticket.status}
                onChange={(event) => changeStatus(event.target.value)}
                className="mt-2 w-full rounded-xl border-slate-200"
              >
                {Object.entries(STATUSES).map(([value, label]) => (
                  <option key={value} value={value}>
                    {label}
                  </option>
                ))}
              </select>
            </label>
          ) : (
            <span
              className={`mt-4 inline-flex rounded-full px-3 py-1 text-xs font-bold ${STATUS_STYLE[ticket.status]}`}
            >
              {STATUSES[ticket.status]}
            </span>
          )}
        </header>
        <div className="flex-1 space-y-4 overflow-y-auto p-6">
          <MessageCard
            author={ticket.requesterEmail}
            text={ticket.description}
            admin={false}
            date={ticket.createdAt}
          />
          {ticket.messages.map((message) => (
            <MessageCard
              key={message.id}
              author={
                message.authorRole === "ADMIN"
                  ? "Administração"
                  : message.authorEmail
              }
              text={message.message}
              admin={message.authorRole === "ADMIN"}
              date={message.createdAt}
            />
          ))}
        </div>
        {ticket.status !== "CLOSED" && (
          <div className="border-t border-slate-200 bg-white p-4">
            <div className="flex gap-2">
              <textarea
                value={reply}
                onChange={(event) => setReply(event.target.value)}
                onKeyDown={(event) => {
                  if (event.key === "Enter" && !event.shiftKey) {
                    event.preventDefault();
                    sendReply();
                  }
                }}
                className="min-h-14 flex-1 rounded-xl border-slate-200"
                placeholder={
                  admin ? "Responder ao cliente…" : "Responder à administração…"
                }
              />
              <button
                onClick={sendReply}
                className="rounded-xl bg-emerald-900 px-4 text-white"
                aria-label="Enviar resposta"
              >
                <PaperAirplaneIcon className="h-5 w-5" />
              </button>
            </div>
          </div>
        )}
      </aside>
    </div>
  );
}
function MessageCard({ author, text, admin, date }) {
  return (
    <div
      className={`rounded-2xl border p-4 shadow-sm ${admin ? "ml-8 border-emerald-200 bg-emerald-50" : "mr-8 border-slate-200 bg-white"}`}
    >
      <div className="flex items-center gap-2">
        <UserGroupIcon className="h-4 w-4 text-slate-400" />
        <b className="text-sm">{author}</b>
        <small className="ml-auto text-slate-400">
          {new Date(date).toLocaleString("pt-PT")}
        </small>
      </div>
      <p className="mt-3 whitespace-pre-wrap text-sm leading-6 text-slate-700">
        {text}
      </p>
    </div>
  );
}
